export const orderAttentionReadEvent = 'fanbird-order-attention-read';
const storageKey = 'fanbird.order-attention.read';
const volatileReadKeys = new Set<string>();
type Attention = { attention_count?: number; attention_keys?: unknown };

const validKeys = (value: unknown): value is string[] => Array.isArray(value)
  && value.every(key => typeof key === 'string' && /^[a-f0-9]{64}$/.test(key));

function readKeys() {
  let stored: unknown;
  try { stored = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch { /* Use memory if storage is unavailable. */ }
  return new Set([...(validKeys(stored) ? stored : []), ...volatileReadKeys]);
}

export function hasUnreadOrderAttention(data: Attention) {
  if (!validKeys(data.attention_keys)) return (data.attention_count || 0) > 0;
  const read = readKeys();
  return data.attention_keys.some(key => !read.has(key));
}

export function markOrderAttentionRead(data: Attention) {
  if (!validKeys(data.attention_keys) || !data.attention_keys.length) return;
  const read = readKeys();
  const unread = data.attention_keys.filter(key => !read.has(key));
  if (!unread.length) return;
  unread.forEach(key => read.add(key));
  try { localStorage.setItem(storageKey, JSON.stringify(Array.from(read))); }
  catch { unread.forEach(key => volatileReadKeys.add(key)); }
  window.dispatchEvent(new Event(orderAttentionReadEvent));
}
